import { Box, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	approveScenario,
	getScenarioDetails,
	getScenariosForApproval,
	setState,
} from "./scenarioApprovalSlice";
import './ScenarioApproval.css'

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { setState as setScenarioState } from "../../Setup/Scenario/scenarioSetupNewSlice";
import { setState as setEditScenarioState, getDataSources, getScenario, getCustGrpRef, getScenarioDetails as ScenarioDetails, getScDSAData } from "../../Setup/Scenario/Edit/editScenarioNewSlice";
import dayjs from "dayjs";
import moment from "moment";

function getScenariosForApprovalColumns(countries) {
	const w = 200;
	const columns = [
		{ field: "scenarioName", headerName: "Scenario", flex: 1 },
		{ field: "criticality", headerName: "Criticality", flex: 1 },
		{
			field: "geoId",
			headerName: "Country Code",
			flex: 1,
			valueGetter: (params) => {
				const countryCode = countries.find(c => c.countryID === params.row.countryID).countryCode;
				return countryCode;
			}
		},
		{ field: "scenarioStatus", headerName: "Status", flex: 1 },
		{
			field: "updatedDate", headerName: "Last Action Date", flex: 1, valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY')
		},
		{ field: "updatedBy", headerName: "Last Action By", flex: 1 },
		{
			field: "reject",
			headerName: "Reject",
			flex: 1,
			renderCell: RejectButton,
		},
		{
			field: "approve",
			headerName: "Approve",
			flex: 1,
			renderCell: ApproveButton,
		},
		{
			field: "isEdit",
			headerName: "Edit",
			flex: 1,
			renderCell: EditButton,
		},
	];
	return columns;


}


export default function Table() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.scenarioApproval);
	const { scenariosForApprovalTable, countries, selectedRows } = state;
	const { rows } = scenariosForApprovalTable;

	const columns = getScenariosForApprovalColumns(countries);
	const [paginationModel, setPaginationModel] = useState({
		pageSize: 20,
		page: 0
	});
	//    useEffect(()=>{
	// 	  let TableData = JSON.parse(JSON.stringify(scenariosForApprovalTable));
	// 	  for( let i = 0; i< TableData.rows.length; i++){
	// 		TableData.rows[i] = getApproveStatus(TableData.rows[i]);
	// 	  }
	// 	  dispatch(setState("scenariosForApprovalTable", TableData ));

	//    },[scenariosForApprovalTable])



	const handleRowClick = (rowData) => {
		if (rowData != undefined) {
			const scenarioId = rowData.row.id;
			dispatch(getScenarioDetails({ scenarioId }));
		}
		if (rowData.length === 0) {
			dispatch(setState("scenarioDetails", null));
		}

	}

	return (
		<Box sx={{ mt: 3 }}>
			<DataGrid style={{ maxHeight: 'calc(100vh - 130px)' }}
				rows={rows}
				columns={columns}
				onRowSelectionModelChange={(selRows) => {
					dispatch(setState("selectedRows", selRows));
					//    if(selRows.length > 0) {
					//       const scenarioId = selRows[selRows.length - 1];
					//       dispatch(getScenarioDetails({ scenarioId }));
					//    }
					//    if(selRows.length === 0) {
					//       dispatch(setState("scenarioDetails", null));
					//    }
				}}				
				sx={{
					'& .MuiDataGrid-cell': {
						whiteSpace: 'normal !important',
						wordWrap: 'break-word !important',
					}
				}}
				rowSelectionModel={selectedRows}
				checkboxSelection
				disableColumnMenu
				//isRowSelectable={false}
				//isRowSelectable={(params) =>  params.row.scenarioStatus !== "Approved" && params.row.scenarioStatus !== "Rejected"}
				isRowSelectable={(params) => params.row.canApproveReject === true}
				disableRowSelectionOnClick
				paginationModel={paginationModel}
				onPaginationModelChange={setPaginationModel}
				pageSizeOptions={[20, 50, 100]}
				// getRowClassName = {(params) => 
				// 	params.row.scenarioStatus === "Approved" || params.row.scenarioStatus === "Rejected"? 'disabled-row': ''
				// }
				getRowClassName={(params) =>
					params.row.canApproveReject !== true ? 'disabled-row' : ''
				}
				onRowClick={handleRowClick}
				headerHeight={40}
			/>
		</Box>
	);
}

// #region Reject Button
function RejectButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();

	function openRejectModal() {
		dispatch(getScenarioDetails({ scenarioId: params.row.id })).then(() => {
			dispatch(setState("rejectScenarioModalOpen", true));
		});
	}

	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<IconButton onClick={openRejectModal}>
				<CancelIcon sx={{ color: "red.main" }} />
			</IconButton>
		);
	}
	return null;
}
// #endregion

// #region Approve Button
function ApproveButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const state = useSelector((store) => store.scenarioApproval);
	const { scenariosForApproval, selectedPeriod, selectedScenarioStatus, selectedCountryID, selectedCountry, searchText } =
		state;

	function search() {
		dispatch(setState("scenarioDetails", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const period = selectedPeriod;
		const scenarioStatus = selectedScenarioStatus;
		const countryId = selectedCountryID;
		const obj = {
			logedUser,
			period,
			scenarioStatus,
			searchText,
			countryId
		};
		dispatch(getScenariosForApproval(obj));
	}
	const approve= (e) =>{
		e.stopPropagation();
		const id = params.row.id;
		const details = preparePayload(id);
		const scenario = scenariosForApproval.find((s) => s.scenarioID === id);
		const user = JSON.parse(localStorage.getItem("data"));
		//const scenarioObj = { ...scenario, user: user };
		const scenarioObj = details;
		dispatch(approveScenario(scenarioObj)).then(() => {
			search();
		});
	}

	function preparePayload(id) {
		const user = JSON.parse(localStorage.getItem("data"));
		const scenario = scenariosForApproval.find((s) => s.scenarioID === id);
		console.log(scenario);
		console.log(user);
		const country = user.userCountries.find(
			(index) => index.country.countryID === scenario.countryID
		).country;

		const formData = new FormData();
		formData.append("countryID", scenario.countryID);
		formData.append("countryName", country.countryName);
		formData.append("countryCode", country.countryCode);
		formData.append(
			"countrySalesOrganizationCode",
			country.countrySalesOrganizationCode
		);
		formData.append("scenarioID", scenario.scenarioID);
		formData.append("effectiveStartDate", scenario.effectiveStartDate);
		formData.append("effectiveEndDate", scenario.effectiveEndDate);
		formData.append("scenarioName", scenario.scenarioName);
		formData.append("scenarioStatus", scenario.scenarioStatus);
		formData.append("updatedBy", scenario.updatedBy);
		formData.append("updatedDate", scenario.updatedDate);
		formData.append("createdBy", scenario.createdBy);
		formData.append("createdDate", scenario.createdDate);
		// formData.append("rejectionComments", "");
		formData.append("canApproveReject", true);
		//formData.append("tranOptions[timeout]", scenario.tranOptions.timeout);
		// formData.append(
		// 	"tranOptions[isolationLevel]",
		// 	scenario.tranOptions.isolationLevel
		// );
		formData.append("user[userID]", user.userID);
		formData.append("user[firstName]", user.firstName);
		formData.append("user[lastName]", user.lastName);
		formData.append("user[email]", user.email);
		formData.append("user[roleID]", user.roleID);
		formData.append("user[roleName]", user.roleName);
		formData.append("user[isAdmin]", user.isAdmin);
		formData.append("user[activeFlag]", user.activeFlag);
		formData.append("user[isFirstTimeUser]", user.isFirstTimeUser);
		formData.append("user[passwordChangeDate]", user.passwordChangeDate);
		formData.append("user[isIMSUser]", user.isIMSUser);

		user.userCountries.forEach((country, index) => {
			formData.append(
				`user[userCountries][${index}][userID]`,
				country.userID
			);
			formData.append(
				`user[userCountries][${index}][country][countryID]`,
				country.country.countryID
			);
			formData.append(
				`user[userCountries][${index}][country][countryName]`,
				country.country.countryName
			);
			formData.append(
				`user[userCountries][${index}][country][countryCode]`,
				country.country.countryCode
			);
			formData.append(
				`user[userCountries][${index}][country][countrySalesOrganizationCode]`,
				country.country.countrySalesOrganizationCode
			);
		});

		user.userCustomerTypes.forEach((type, index) => {
			formData.append(
				`user[userCustomerTypes][${index}][userID]`,
				type.userID
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeCode]`,
				type.customerTypeBO.customerTypeCode
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeName]`,
				type.customerTypeBO.customerTypeName
			);
		});
		formData.append("user[token]", user.token);

		return formData;
	}


	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<IconButton onClick={approve}>
				<CheckCircleIcon sx={{ color: "green.main" }} />
			</IconButton>
		);
	}
	return null;
}
//#endregion

// #region Edit Button
function EditButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const scenarioApprovalState = useSelector((store) => store.scenarioApproval);
	const { scenariosForApproval, countries, selectedCountry } = scenarioApprovalState;

	function gotoEditScenario() {
		const id = params.row.id;
		const scenario = scenariosForApproval.find((s) => s.scenarioID === id);
		const { scenarioName, effectiveStartDate, effectiveEndDate } = scenario;

		// #endregion
		dispatch(setScenarioState("editMode", true));
		navigate("/setup/scenario");

		const obj = {
			countryID: scenario.countryID,
			selectedCountry: countries.find((country) => country.countryID === scenario.countryID
			).countryName,
			scenarioName: scenarioName,
			createFromDate: effectiveStartDate,
			createToDate: effectiveEndDate,
			scenarioID: id
		}
		// #region Set Scenario Values
		dispatch(setEditScenarioState("countryID", scenario.countryID));
		dispatch(setEditScenarioState("selectedCountry", countries.find(
			(country) => country.countryID === scenario.countryID
		).countryName));
		const countryID = scenario.countryID;
		dispatch(getDataSources({ countryID }));
		dispatch(getCustGrpRef({ countryID }));
		const objsearch = {
			countryId: countryID,
			scenario: "",
			fromDate: "",
			toDate: ""
		};
		console.log("SearchScenario", objsearch);
		dispatch(getScenario(objsearch)).then(() => {
			dispatch(setEditScenarioState("editScID", id));
			dispatch(setEditScenarioState("editScName", scenarioName));
		});
		const objdetails = {
			scenarioId: id,
		};
		dispatch(ScenarioDetails(objdetails));
		dispatch(getScDSAData(objdetails));
	}

	if (params.row.canEdit && isRestrictedAccess) {
		return (
			<IconButton>
				<EditNoteIcon onClick={gotoEditScenario} sx={{ color: "blue.main" }} />
			</IconButton>
		);
	}
	return null;
}
// #endregion
